<template>
  <div  element-loading-spinner="el-icon-loading" class="buyerlistDiv">
    <div class="listLength">已找到公司:{{totalNum}}</div>
    <el-table
    class="fine-scroll-bar"
        ref="multipleTable"
        :data="data"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        :height="$store.state.userInfo.loginAsManagerId>0?'calc(100vh - 256px)':'calc(100vh - 210px)'"
        >
        <template slot="empty">
          <div class="emptycontent">
            <div class="emptycontentimg">
              <img src="@/assets/image/common/buyernoData.png" alt="">
            </div>
            <div class="emptycontenttitle">
              无法找到任何与搜索内容匹配的潜在客户
            </div>
            <div class="emptycontentagain">
              请尝试不同的搜索过滤参数或减少过滤参数数量
            </div>
            <div class="emptycontentbtn">
              <el-button v-no-more-click @click="resets">重置过滤器</el-button>
            </div>
          </div>
        </template>
      <el-table-column
        type="selection"
        align="center"
        width="65" :selectable="selectable">
      </el-table-column>
      <el-table-column  >
        <!-- 重置头部 -->
        <template slot="header" slot-scope="scope" >
          <!-- 4/7 nicole 分组暂时先不加这个功能，后期可能会加上 -->
          <!-- <el-popover
            v-if="multipleSelection.length>0"
            placement="bottom"
            width="200"
            trigger="click"
            content=""
            @hide="hide">
            <div class="content">
              <div class="add" >
                <div class="addName" @click="addShow" v-if="!addNameShow">+创建新列表</div>
                <div class="addFrom" v-else>
                  <el-input placeholder="输入列表名称"  v-model="groupName" clear @blur="blur">
                    <template slot="append">
                      <el-button type="primary" @click="addItem">创建</el-button>
                    </template>
                  </el-input>
                </div>
              </div>
              <div class="errAddName" v-if="addValShow">请输入新的列表名称</div>
              <div v-for="(item,index) in MyGroupData" :label="item" :key="index" class="contentArr">
                <div @click="handleCheckedCitiesChange(item,index)" class="item" :class="index==active?'active':''">
                  {{item.groupName}}
                </div>
              </div>
            </div>
            <div slot="reference">
              <el-tooltip placement="top" effect="light">
                <div slot="content">将联系人添加至您的收件<br/>人列表(消耗一个点数)</div>
                <el-button type="primary" size="mini" @click="addMan" >+添加到联系人</el-button>
              </el-tooltip>
            </div>
          </el-popover> -->
          <div  v-if="multipleSelection.length>0">
            <el-tooltip placement="top" >
              <div slot="content" >将联系人批量添加至您的潜在客户<br/>列表（根据添加数量消耗点数）</div>
              <el-button v-no-more-click type="primary"  size="mini" @click="addManAll" >+添加到潜在客户</el-button>
            </el-tooltip>
          </div>
          <div v-else>姓名</div>
        </template>
        <!-- 内容 -->
        <template slot-scope="scope">
          <div  >
            <div class="Highlight" @click="visibleShow('F',scope)">
              {{ scope.row.contactName }}
            </div>
            <div class="overflowTooltip">
                {{ scope.row.titleStr }}
            </div>
          </div>
          <!-- <div class="overflowTooltip"></div> -->
          <el-tooltip placement="bottom-start" >
            <div slot="content">查看LinkedIn个人主页</div>
              <div @click="linkedinLinkShow(scope)" class="linkedin" v-if="scope.row.linkedinLink">
                <i class="iconfont icon-yingling"></i>
              </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        :label="multipleSelection.length>0?'':'公司'"
        >
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.companyName |noText" placement="top">
            <div class="Highlight overflowTooltip" @click="visibleShow('Y',scope)">{{ scope.row.companyName |noText}}</div>
          </el-tooltip>
         
          <div class="scopeIcon"><i class="iconfont icon-icon-dingweidizhi"></i>{{areaFmater(scope.row.cityStr,scope.row.stateStr,scope.row.countryStr)}}</div>
          <div class="scopeIcon"><i class="iconfont icon-icon-hangye"></i> {{scope.row.industryStr}}</div>
          <!-- {{ scope.row.address }} -->
        </template>
      </el-table-column>
      <el-table-column
        prop="address"
        :label="multipleSelection.length>0?'':'邮箱地址'"
        show-overflow-tooltip>
        <template slot-scope="scope" >
          <span v-if="scope.row.isAddCustomer!=1" class="explain">
            添加后获取邮箱
          </span>
          <div v-else class="overflowTooltip">{{scope.row.email||'---'}}</div>
        </template>
      </el-table-column>
      <el-table-column  align="center">
        <template slot="header" slot-scope="scope"  >
          <div v-if="multipleSelection.length>0" class="multipleSelectionList">已选择{{multipleSelection.length}}个，共{{data.length}}个</div>
          <div v-else>操作</div>
        </template>
        <template slot-scope="scope">
          <!-- 4/7 nicole 分组暂时先不加这个功能，后期可能会加上 -->
          <!-- <div v-if="scope.row.isbuye==1" class="scopeDiv">
            <el-popover
              placement="bottom"
              width="200"
              trigger="click"
              content=""
              @hide="hide">
              <div class="content">
                <div class="add" >
                  <div class="addName" @click="addShow" v-if="!addNameShow">+创建新列表</div>
                  <div class="addFrom" v-else>
                    <el-input placeholder="输入列表名称"  v-model="groupName" clear @blur="blur">
                      <template slot="append">
                        <el-button type="primary" @click="addItem">创建</el-button>
                      </template>
                    </el-input>
                  </div>
                </div>
                <div class="errAddName" v-if="addValShow">请输入新的列表名称</div>
                <div v-for="(item,index) in MyGroupData" :label="item" :key="index" class="contentArr">
                  <div @click="handleCheckedCitiesChange(item,index)" class="item" :class="index==active?'active':''">
                    {{item.groupName}}
                  </div>
                </div>
              </div>
              <div slot="reference">
                <el-tooltip placement="top" effect="light">
                  <div slot="content">将联系人添加至您的收件<br/>人列表(消耗一个点数)</div>
                  <el-button type="primary" size="mini" @click="addMan" >+添加到联系人</el-button>
                </el-tooltip>
              </div>
            </el-popover>
          </div> -->
          <div v-if="scope.row.isAddCustomer!=1">
            <el-tooltip placement="top" >
              <div slot="content" >将联系人添加至您的潜在客户<br/>列表(消耗一个点数)</div>
              <el-button v-no-more-click type="primary" size="mini" @click="addMan(scope)" >+添加到潜在客户</el-button>
            </el-tooltip>
          </div>
          <div v-else  >
            <el-button class="addBtn"  @click="topotential(scope)">
              管理潜在客户
            </el-button>
            <!-- 添加标签 -->
            <AddTags
              :customerId="scope.row.customerId"
              :tagedCollect="scope.row.supplierTagVoList || []"
            >
              <i class="addtag iconfont icon-icon-gengduo2"></i>
            </AddTags>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div v-if="visible">
      <drawerDetails 
        ref="drawer"
        :details="details" 
        @changeClose="$event=>{ visible = $event }" 
        :visible="visible" 
        :companyId="companyId" 
        :contactId="contactId" 
        @addManClick="addManClick"
        @fastSearch="$event=> $emit('fastSearch', $event)"
      />
    </div>
    <!-- 购买图片弹框点数不足 -->
    <vipBoxDialog :vipCode="vipCode" ref="vipBoxDialog"/>
  </div>
</template>

<script>
import drawerDetails from "@/components/overseas-buyer/drawerDetails"
import AddTags from "@/components/overseas-buyer/addTags.vue"
import {addToRecipient,queryMyGroup,buyerAddGroup,} from "@/utils/api/seamark"
import {imgRes} from "@/utils/config"
import vipBoxDialog from "@/components/common/VIPdialog"
import { mapMutations } from 'vuex'
  export default {
    props:{
      data:{
        type:Array,
        default:[]
      },
      totalNum:{
        type:Number,
        default:0
      },
      loading:{
        type:Boolean,
        default:false
      }
    },
    data() {
      return {
        imgRes:imgRes,
        dialogShow:false,
        visible:false,
        details:'1',
        addNameShow:false,
        addValShow:false,
        groupName:'',
        active:0,
        cities:['默认联系人组', '西门子', '西门子1', '西门子2'],
        checkedCities: ['上海'],
        lastArr:[],
        multipleSelection: [],
        companyId:-1,
        id:'',
        MyGroupData:[],
        multipleSelectionId:[],
        contactId:-1,
        vipCode:7002,//7001, "套餐可用额度不足" ,  7002, "套餐无可用额度
      }
    },
    components:{
      drawerDetails,
      AddTags,
      vipBoxDialog
    },
    methods: {
      ...mapMutations('linkedin', ['SET_VISIBLE', 'SET_LINKIN_URL']),
      // 跳转潜在客户管理
      topotential(scope){
        console.log(scope)
        // this.$router.push({
        //   name: 'customer-management', query:{
        //     customerId:scope.row.customerId
        //   }
        // });
        let routeUrl = this.$router.resolve({
          path: "/customer-management",
          query:{
            customerId:scope.row.customerId
          }
        });
        window.open(routeUrl.href, '_blank');
      },
      // 区域处理
      areaFmater(cityStr,stateStr,countryStr){
        let item=[]
        if(cityStr){
          item.push(cityStr)
        }
        if(stateStr){
          item.push(stateStr)
        }
        if(countryStr){
          item.push(countryStr)
        }
        return item.length>0?item.join():'---'
      },
      // 获取我的联系人分组
      async getQueryMyGroup(){
        const res=await queryMyGroup()
        console.log(res)
        this.MyGroupData=res.rspListData.list
        // if(res.rspResult.bizCode==200){
        //   this.companyData=res.data
        // }else{
        //   this.$message.error(res.rspResult.message);
        // }
      },
    // 弹框隐藏需要清空里里面的组件
      hide(){
        this.addNameShow=false
      },
      //查看的是个人详情还是公司详情
      visibleShow(type,scope){
        this.details=type
        if(type=='F'){//个人
          this.contactId=scope.row.contactId
          this.companyId=-1
        }
        if(type=='Y'){//公司
          this.companyId=scope.row.companyId
          this.contactId=-1
        }
        this.visible=true
        if(type=='Y'){
          let source={
            desCn:scope.row.desCn,
            desEn:scope.row.desEn
          }
          this.$nextTick(()=>{
            this.$refs.drawer.sourceData(source)
          })
        }
      },
      // 表格选中
      handleSelectionChange(val) {
        console.log(val)
        this.multipleSelection = val;
        this.multipleSelectionId=[]
        this.multipleSelection.map(item=>{
          this.multipleSelectionId.push(item.contactId)
        })
        // console.log(itemArr.join())
        // this.multipleSelectionId=itemArr.join()
      },
      // 禁止已经添加的联系人列选中
      selectable(row, index){
        return row.isAddCustomer!=1
      },
      // 添加联系人
      handleCheckedCitiesChange(value,index){
        console.log(index)
        this.active=index
        // 联系人添加成功
         this.$message({
          message: '联系人添加成功',
          type: 'success'
        });
      },
      // 添加联系人创建新列表
      addShow(){
        this.addNameShow=!this.addNameShow
      },
      // 添加联系人新列表 // 添加采购商联系人分组
     async addItem(){
        if(this.groupName==''){
         this.addValShow=true
        }else{
          let prams={
            groupName:this.groupName
          }
          // this.cities.push(this.groupName)
          const res=await buyerAddGroup(prams)
          this.getQueryMyGroup() 
          this.groupName=''
        }
      },
      // 创建新列表校验
      blur(){
        if(this.groupName==''){
        //  this.addValShow=true
        }else{
         this.addValShow=false
        }
      },
      /**
       * // 添加联系人按钮事件, 未购买营销产品包客户，点击“添加联系人”，
       * // 弹窗显示升级提示。点击“立即升级”跳转至产品购买页。产品购买页新开页打开
      **/
      async addMan(scope){
        //点数不够弹框或者未买点数弹框
        
        // this.getQueryMyGroup() 
        let itemArr=[]
        itemArr.push(scope.row.contactId)
        let prams={
          "contactIds": itemArr
        }
        this.$emit('vloadingfn',true)
        const res =await addToRecipient(prams)
        console.log(res)
        if(res.rspResult.bizCode==200){
          // successNumber
          if(res.data.successNumber>0){
            this.$message.success(`已添加${res.data.successNumber}个潜在客户`)
          }else if(res.data.successNumber==-9999){
            this.$message.warning(`系统繁忙，请稍后再试`)
          }else{
            this.$message.success(`已添加潜在客户`)
          }
          // 刷新列表
          this.addManClick()
          this.$emit('vloadingfn',false)
        }else if(res.rspResult.bizCode==7001||res.rspResult.bizCode==7002){
          this.vipCode=res.rspResult.bizCode
          this.$refs.vipBoxDialog.centerDialogVisible=true
          this.$emit('vloadingfn',false)
        }else{
          this.$message.error(res.rspResult.message)
          this.$emit('vloadingfn',false)
        }

      },
      // 刷新列表 
      addManClick(){
        this.$emit('addManRefresh')
      },
      async addManAll(){
        let prams={
          "contactIds": this.multipleSelectionId
        }
        this.$emit('vloadingfn',true)
        const res =await addToRecipient(prams)
        if(res.rspResult.bizCode==200){
          // successNumber
          if(res.data.successNumber>0){
            this.$message.success(`已添加${res.data.successNumber}个潜在客户`)
          }else if(res.data.successNumber==-9999){
            this.$message.warning(`系统繁忙，请稍后再试`)
          }else{
            this.$message.success(`已添加潜在客户`)
          }
          // 刷新列表
          this.addManClick()
          this.$emit('vloadingfn',false)
        }else if(res.rspResult.bizCode==7001||res.rspResult.bizCode==7002){
          this.vipCode=res.rspResult.bizCode
          this.$refs.vipBoxDialog.centerDialogVisible=true
          this.$emit('vloadingfn',false)
        }else{
          this.$message.error(res.rspResult.message)
          this.$emit('vloadingfn',false)
        }
      },
      // 跳转linkin
      linkedinLinkShow(scope) {
        this.SET_VISIBLE(true)
        this.SET_LINKIN_URL(scope.row.linkedinLink)
      },
      // 重置搜索条件
      resets(){
       this.$emit('resetsFun')
      },
    },
    mounted(){
      
    }
  }
</script>
<style lang="scss" scoped>
.add{
  border-bottom: 1px solid  #EDF0F4;
  margin-bottom: 6px;
  padding-bottom: 16px;
  .addName{
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    font-size: 12px;
    color: #066EB7;
    padding-left: 12px;
    cursor: pointer;
  }
}
.contentArr{
  height: 40px;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 12px;
  color: #16181A;
  line-height: 40px;
  
  .item{
    padding-left: 12px;
    cursor: pointer;
  }
  .item:hover{
    background: #F5F7FA;
  }
}
.active{
  background: #F5F7FA;
}
.errAddName{
  color: red;
}
.listLength{
  // margin-bottom: 18px;
  padding-left: 40px;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #16181A;
  line-height: 44px;
}
.explain{
  // width: 120px;
  height: 44px;
  // background: #066eb71a;
  border-radius: 4px;
  // text-align: center;
  // padding: 0px 8px;
  font-weight: 400;
  font-size: 12px;
  color: #4F5D78;
  letter-spacing: 0;
  // text-align: center;
}
.scopeIcon{
  .iconfont{
    font-size: 12px;
    margin-right: 4px;
  }
}
.Highlight{
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #066EB7;
  cursor: pointer;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.emptycontent{
  .emptycontentimg{
    width: 322px;
    height: 100px;
    // background: gray;
    margin: 0 auto;
    margin-top: 200px;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .emptycontenttitle{
    font-family: SourceHanSansCN-Bold;
    font-weight: 700;
    font-size: 16px;
    color: #16181A;
    line-height: 30px;
    margin-top: 10px;
  }
  .emptycontentagain{
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    font-size: 12px;
    color: #4F5D78;
    line-height: 30px;
    
  }
  .emptycontentbtn{
    margin-bottom: 200px;
  }
}
.linkedin{
  cursor: pointer;
  width: 30px;
  .iconfont{
    color: #066EB7;
  }
}
.addBtn{
  background: #F5F7FA;
  border-radius: 4px;
  // width: 72px;
  // height: 28px;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 12px;
  color: #16181A;
}
.addtag {
  margin-left: 16px;
  font-size: 14px;
  color: #98A3B7;
  cursor: pointer;
  user-select: none;
}
.multipleSelectionList{
  font-size: 14px;
}
.buyerlistDiv{
  .el-table{
    font-size: 14px !important;
  }
}
.mediumTitle{
  font-size: 14px;
}
</style>

